import { render } from "./RolesList.vue?vue&type=template&id=1496ded9&scoped=true"
import script from "./RolesList.vue?vue&type=script&lang=js"
export * from "./RolesList.vue?vue&type=script&lang=js"

import "./RolesList.vue?vue&type=style&index=0&id=1496ded9&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1496ded9"]])

export default __exports__